export enum PaymentMethods {
  card = 'CC',
  paypal = 'PayPal',
  applePay = 'ApplePay',
  googlePay = 'GooglePay',
}

export const RELEASE_VERSION = '3.61.2';

export default defineNuxtPlugin(() => {
  return {
    provide: {
      paymentMethods: PaymentMethods,
      releaseVersion: RELEASE_VERSION,
    },
  };
});
